// extracted by mini-css-extract-plugin
module.exports = {"turnstile":"Turnstile_turnstile___tfu8"};